<template>
  <div class="home">
    <bar-top></bar-top>
    <!-- Hello
    $auth.ready() = {{$auth.ready()}}
    $auth.check() = {{$auth.check()}} -->
    <!-- <v-btn >Normal</v-btn>
    <br/>
    $auth.ready() = {{$auth.ready()}}
    <br/>
    $auth.check() = {{$auth.check()}} -->
    <!-- <ul>
      <li><router-link to="/view_admin">ViewAdmin</router-link></li>
      <li><router-link to="/upload_test">UploadTest</router-link></li>
      <li>
        <v-btn v-on:click.native="$router.push('/login')" v-if="!$auth.check()">Login</v-btn>
        <v-btn v-on:click.native="$auth.logout()" v-if="$auth.check()">Logout</v-btn>
      </li>
    </ul> -->
  </div>
</template>

<script>
import barTop from '../components/BarTop.vue'
export default {
  name: 'home',
  components: {
    barTop
  },
  mounted () {
    // console.log('mounted')
    if (!this.$auth.check()) {
      this.$router.push('/login')
    }
  }
  // updated () {
  //   console.log('updated')
  //   if (!this.$auth.check()) {
  //     this.$router.push('/login')
  //   }
  // },
  // beforeUpdate () {
  //   console.log('beforeUpdate')
  //   if (!this.$auth.check()) {
  //     this.$router.push('/login')
  //   }
  // },
  // beforeDestroy () {
  //   console.log('beforeDestroy')
  //   if (!this.$auth.check()) {
  //     this.$router.push('/login')
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// Home.vue?7d4292d9